export default {
    termsUpdated: '<0>Click here</0> if you’d like to review our Terms of Use.',
    alertVerifyEmail: 'Your email address is currently unverified. Please <0>verify</0> your email.',
    alertError: 'Sorry, something went wrong. Please try again later.',
    alertErrorReportNotFound: "We're sorry, your report could not be found. Please see our support page <0>here</0>.",
    alertErrorReportNotFoundAlt:
        "We're sorry, we seem to have run into an issue with your account. Please see our support page <0>here</0>.",
};
